
/**
 * 강의 난이도
 */
export type CourseSummaryLevel = typeof CourseSummaryLevel[keyof typeof CourseSummaryLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseSummaryLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
